import React, { useEffect, useMemo, useState } from 'react';

import { Link } from 'react-router-dom';

import Layout from '../../components/Layout/Layout';

import SeoHead from '../../components/Seo/SeoHead';

import seoService from '../../services/seoService';

import { FEATURES } from '../../content/features/catalog';

import styles from './Features.module.css';



const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'https://comics-earth.fr';



const Features = () => {

  const [seo, setSeo] = useState(null);



  const fallbackSeo = useMemo(() => ({

    metaTitle: 'Fonctionnalités | Earth Forum',

    metaDescription: 'Découvrez les fonctionnalités d\'Earth Forum et comment en profiter.',

    canonical: `${FRONTEND_URL}/fonctionnalites`,

    robotsIndex: true,

  }), []);



  useEffect(() => {

    seoService.getFeatures().then(setSeo).catch(() => setSeo(null));

  }, []);



  return (

    <Layout wide>

      <SeoHead seo={seo || fallbackSeo} />

      <div className={styles.page}>

        <header className={styles.header}>

          <h1 className={styles.title}>Fonctionnalités</h1>

          <p className={styles.subtitle}>

            Retrouvez ici les principales fonctionnalités du forum, avec des pages explicatives

            pour comprendre leur utilité et comment en profiter.

          </p>

        </header>



        <div className={styles.list}>

          {FEATURES.map((feature) => (

            <article key={feature.slug} className={styles.card}>

              <Link to={`/fonctionnalites/${feature.slug}`} className={styles.cardLink}>

                <p className={styles.cardCategory}>{feature.category}</p>

                <h2 className={styles.cardTitle}>{feature.title}</h2>

                <p className={styles.cardSummary}>{feature.summary}</p>

                <span className={styles.cardCta}>En savoir plus →</span>

              </Link>

            </article>

          ))}

        </div>

      </div>

    </Layout>

  );

};



export default Features;

